module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.0-258.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.7.0.md
// module id = 701
// module chunks = 252